<template>
	<div>
		<h3>Stats</h3>

		<b-tabs>
			<b-tab title="General">
				Utilisateurs: {{users.length}}<br />
				Projets: {{list_projects.length}}<br />
				Nombre de lignes dans la base de données: {{nb_lines}}
			</b-tab>
			<b-tab title="Utilisateurs">
				<p>
					Nombre d'utilisateurs théorique : {{users.length}}<br />
					Utilisateurs avec date de dernière connexion : {{last_date_login}}<br />
					Utilisateurs s'étant connectés il y a moins d'un mois : {{last_date_login_month}}<br />
					Utilisateurs en attente de redéfinir leurs mots de passe : {{is_token_new_password}}
				</p>
				<b-table striped hover :items="users" sort-by="last_date_login" :sort-desc="true" :fields="[
					{
						key: 'identifiant',
						label: 'Identifiant',
						sortable: true,
					},
					{
						key: 'prenom',
						label: 'Prénom',
						sortable: true,
					},
					{
						key: 'nom',
						label: 'Nom',
						sortable: true,
					},
					{
						key: 'email',
						label: 'email',
						sortable: true,
					},{
						key: 'groups',
						label: 'Groupes',
						sortable: true,
					},{
						key: 'is_token_new_password',
						label: 'Demande nouveau mp',
						sortable: true,
					},{
						key: 'last_date_login',
						label: 'Dernière connexion',
						sortable: true,
					}]">
					<template v-slot:cell(is_token_new_password)="data">
						{{data.item.is_token_new_password ? "oui" : ""}}
					</template>
				</b-table>
				<h3>Téléchargement</h3>
				<p>Filtrer par groupe</p>
				<b-input v-model="filter_group"></b-input><br />
				<b-button @click="dowload(false, false)">Tous les utilisateurs</b-button><br /><br />
				<b-button @click="dowload(true, false)">Sans dernière connexion</b-button><br /><br />
				<b-button @click="dowload(false, true)">Avec redéfinition de mot de passe</b-button><br /><br />
				<b-button @click="dowload(true, true)">Sans dernière connexion et avec redéfinition de mot de passe</b-button>
			</b-tab>
			<b-tab v-for="(dashboard, idx) in dashboards" :key="idx" :title="dashboard">
				<Dashboard :minimal="true" :_name="dashboard"></Dashboard>
			</b-tab>
			<b-tab title="Projets">
				<ProjectsStats></ProjectsStats>
			</b-tab>
			<b-tab title="Traitements">
				<TreatmentsStats></TreatmentsStats>
			</b-tab>
		</b-tabs>
	</div>
</template>

<script>
	import moment from "moment";
	require('moment/locale/fr')

	var clone = require("clone");
	const json2csv = require("json2csv").parse;

	import store from "../store";
	import Dashboard from "./Dashboard.vue";
	import utils from "../services/utils.js";
	import users from "../services/users.js";
	import client from "../services/client.js";
	import database from "../services/database.js";
	import projects from "../services/projects.js";
	import ProjectsStats from "./ProjectsStats.vue";
	import TreatmentsStats from "./TreatmentsStats.vue";

	export default {
		name: "stats",
		components: {
			ProjectsStats,
			TreatmentsStats,
			Dashboard
		},
		data() {
			return {
				users: [],
				is_token_new_password: 0,
				list_projects: [],
				last_date_login: 0,
				last_date_login_month: 0,
				nb_lines: 0,
				dashboards: [],
				filter_group: ""
			}
		},
		methods: {
			dowload(last_connexion, new_password)
			{
				var users = [];

				for (var i = 0; i < this.users.length; i++)
				{
					var c = true;

					if (last_connexion && this.users[i].last_date_login)
						c = false;
					else if (new_password && !this.users[i].is_token_new_password)
						c = false;
					else if (this.filter_group && (!this.users[i].groups || !this.users[i].groups.includes(this.filter_group)))
						c = false;

					if (c)
						users.push(this.users[i])
				}

				var str_csv = json2csv(users, {
					fields: ["identifiant", "prenom", "nom", "email", "groups", "is_token_new_password", "last_date_login"],
					fieldNames: ["identifiant", "prenom", "nom", "email", "groups", "is_token_new_password", "last_date_login"],
					del: ",",
					quote: '"'
				});

				utils.saveToFile(str_csv, "utilisateurs.csv");
			}
		},
		created: async function () {
			
			if (store.state.user.rules && !store.state.user.rules.treatments_stats) {
				this.$router.push({ name: "profile" });
			}

			this.users = (await client.getClientUsers()).users;
			var groups = await client.getClientGroups();

			var obj_groups = {};
			for (var i = 0; i < groups.length; i++) {
				obj_groups[groups[i].uid] = groups[i];
			}

			for (var i = 0; i < this.users.length; i++) {
				if (this.users[i].groups) {
					this.users[i].groups = this.users[i].groups.split("|");
					for (var j = 0; j < this.users[i].groups.length; j++) {
						this.users[i].groups[j] =
							obj_groups[this.users[i].groups[j]].name;
					}
					this.users[i].groups = this.users[i].groups.join(", ");
				}
				if (this.users[i].archive)
				{
					this.users[i].actif = "non";
					if (this.users[i].details && this.users[i].details.register)
						this.users[i].actif = "Validation en cours";
				}
				else 
					this.users[i].actif = "oui";
			}

			var date = moment().subtract(1, "months");
			for (var i = 0; i < this.users.length; i++)
			{
				if (this.users[i].is_token_new_password)
					this.is_token_new_password++;
				if (this.users[i].last_date_login)
				{
					this.last_date_login++;
					if (moment(this.users[i].last_date_login).isAfter(date))
						this.last_date_login_month++;
				}
			}
			this.list_projects = await projects.getAll(false, true);

			let response = await users.getSelf(true);
			this.client = response.client;
			if (this.client.details && this.client.details.dashboard_stats)
			{
				this.dashboards = this.client.details.dashboard_stats.split("|");
			}
			if (this.client.details && this.client.details.tables)
			{
				var tables = this.client.details.tables;
				this.nb_lines = 0;
				if (tables && tables.length > 0) {
					var child = [];
					for (var i = 0; i < tables.length; i++) {
						var lines = await database.get(
							"SELECT",
							tables[i].name,
							{ select: "count(*)" }
						);
						if (lines && lines.length > 0) {
							this.nb_lines += lines[0]["count(*)"];
						}
					}
				}
			}
		},
	};
</script>

<style>
	.rowClass {
		background-color: pink;
	}
</style>
